import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { Box, IconButton, Typography } from '@mui/material'

import { VisuallyHiddenInput } from 'components'
import { ADMIN_CONTACT_EMAIL } from 'config'
import { color } from 'config/color'
import { isEmpty } from 'lodash'
import type React from 'react'
import { type ChangeEvent } from 'react'
import { isAuthorized, useProvideAuth } from 'utils'

interface UploadAssetCardProps {
  setIsLoading: any
  handleAssets: () => Promise<void>
  setDialogData: any
  setEditCarouselData: any
}
export const UploadAssetCard: React.FC<UploadAssetCardProps> = (
  props: UploadAssetCardProps
) => {
  const { uploadAssets, handleLogOut } = useProvideAuth()

  const handleUpload = async (
    event: ChangeEvent<HTMLInputElement>
  ): Promise<void> => {
    const files = event.target.files
    if (files != null) {
      try {
        props.setIsLoading(true)
        const formData = new FormData()
        Array.from(files).forEach((file) => {
          formData.append('assets', file)
        })
        const response = await uploadAssets(formData)

        const failedFiles = response.result.filter(
          (item: any) =>
            item.status === 'FAILED' && item.error === 'Duplicate Asset Name'
        )

        if (isEmpty(failedFiles)) {
          props.setDialogData({
            type: 'success',
            isOpen: true,
            title: 'Assets have been uploaded',
            message:
              'You have successfully uploaded an asset and now its ready to be use in your campaigns.'
          })
        } else {
          props.setEditCarouselData({
            isOpen: true,
            failedFiles,
            fileData: files
          })
        }
        props.setIsLoading(false)
      } catch (error: any) {
        if (!isAuthorized(error)) await handleLogOut()
        props.setDialogData({
          type: 'error',
          isOpen: true,
          title: 'An error occured',
          message: `We are really sorry but there was a problem and we couldn’t save the asset. Please try again, if the error persist, <a href="mailto:${ADMIN_CONTACT_EMAIL}" >Contact Us</a>. `
        })
      }
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      bgcolor={color.grey[50]}
      border={`1px solid ${color.secondary.dark[100]}`}
      height="20vh"
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Box>
        <Box display="flex" flexDirection="column" gap={1} alignItems="center">
          <IconButton
            sx={{
              display: 'flex',
              bgcolor: color.secondary.dark[100]
            }}
            component="label"
          >
            <CloudUploadIcon
              sx={{ color: color.primary[600], fontSize: '32px' }}
            />

            <VisuallyHiddenInput
              type="file"
              accept="image/*"
              onChange={handleUpload}
              multiple
            />
          </IconButton>

          <Typography
            textTransform="capitalize"
            color={color.grey[700]}
            fontWeight={400}
            fontSize={16}
          >
            Upload new asset
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
